"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneVerificationWithForm = void 0;
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components/");
var react_final_form_1 = require("react-final-form");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var PhoneVerificationWithForm = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var values = _a.values, initialValue = _a.initialValue, onModalOpen = _a.onModalOpen, isPhoneVerified = _a.isPhoneVerified, isDeposit = _a.isDeposit, country = _a.country;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var tPhone = (0, next_intl_1.useTranslations)('phoneVerification');
    var formState = (0, react_final_form_1.useFormState)();
    var _h = (0, swr_hooks_1.useSendPhoneVerificationSms)({}), sendPhoneVerificationSms = _h.sendPhoneVerificationSms, isSubmitting = _h.isSubmitting;
    var _j = (0, react_1.useState)(null), errorPhoneUpdate = _j[0], setErrorPhoneUpdate = _j[1];
    var updateProfile = (0, swr_hooks_1.useUpdateProfileData)({
        successAction: function () {
            sendPhoneVerificationSms({
                input: {
                    phone: formState.values.phone,
                },
            });
            onModalOpen === null || onModalOpen === void 0 ? void 0 : onModalOpen();
        },
        errorAction: function (err) {
            setErrorPhoneUpdate(err);
        },
    }).updateProfile;
    var data = (0, swr_hooks_1.useBonusesForPhoneVerification)().data;
    var sendVerificationCode = (0, react_1.useCallback)(function () {
        if (formState.values.phone)
            updateProfile({ phone: formState.values.phone });
    }, [formState.values.phone, updateProfile]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isPhoneVerified ? styles_module_scss_1.default.verified : '', " ").concat(isDeposit ? styles_module_scss_1.default.deposit : '') },
        react_1.default.createElement(react_final_form_1.Field, { name: "phone", render: function (_a) {
                var _b, _c;
                var input = _a.input, meta = _a.meta;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { value: input.value || initialValue || '', country: country
                            ? country
                            : !(input.value || initialValue)
                                ? (_c = (_b = values === null || values === void 0 ? void 0 : values.country) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.toLowerCase()
                                : undefined, onChange: function (data) {
                            input.onChange(data);
                            if (errorPhoneUpdate)
                                setErrorPhoneUpdate(null);
                        }, isDisabled: isPhoneVerified, placeholder: t('phone'), labelText: !isDeposit ? t('phone') : undefined, helperButton: isPhoneVerified
                            ? { type: 'verified' }
                            : meta.error && meta.touched && { type: 'error' }, tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: t.raw('lockPersonalData'),
                            } }) })),
                    errorPhoneUpdate && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                        react_1.default.createElement(ui_components_1.ErrorText, null, tErr("".concat(errorPhoneUpdate))))),
                    meta.error && meta.touched && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                        react_1.default.createElement(ui_components_1.ErrorText, null, meta.error)))));
            } }),
        !isPhoneVerified && (react_1.default.createElement(react_1.default.Fragment, null,
            !isDeposit && ((_c = (_b = data === null || data === void 0 ? void 0 : data.bonuses) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.title) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusContainer },
                react_1.default.createElement("div", null, tPhone('completePhoneVerificationAndReceive')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, (_e = (_d = data === null || data === void 0 ? void 0 : data.bonuses) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.title))) : null,
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.btnWrapper, " ").concat(isDeposit ? styles_module_scss_1.default.withoutBonus : '') },
                react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", maxWidth: "none", loading: isSubmitting, disabled: ((_f = formState.errors) === null || _f === void 0 ? void 0 : _f.phone) || !Boolean(((_g = values === null || values === void 0 ? void 0 : values.phone) === null || _g === void 0 ? void 0 : _g.length) >= 8), onClick: sendVerificationCode }, tPhone('sendVerificationCode')))))));
};
exports.PhoneVerificationWithForm = PhoneVerificationWithForm;
